import { HttpResponse } from "@angular/common/http";
import { Component, OnDestroy, OnInit } from "@angular/core";
import {
  AbstractControl, FormArray, FormControl, FormGroup, ValidationErrors,
  ValidatorFn, Validators
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from "pdfmake/build/vfs_fonts";
import {
  concatMap,
  debounceTime,
  distinctUntilChanged,
  filter,
  firstValueFrom,
  forkJoin,
  Observable,
  of,
  ReplaySubject,
  Subscription,
  tap,
  throttleTime
} from "rxjs";
import { takeUntil } from 'rxjs/operators';
import {
  isFirmaSubmitLocked,
  isGeneratePdfReady,
  logAutofirmaError,
  releaseFirmaSubmitLock,
} from 'src/app/_helpers/firma-submit.guard';
import { bloquearSiProcedimientoNoActivo } from 'src/app/_helpers/procedimiento-activo.util';
import { bloquearSiTramiteDadoDeBaja } from 'src/app/_helpers/tramite-baja.util';
import { UnsubscribeOnDestroy } from 'src/app/_helpers/unsubscribe-on-destroy';
import { ClientFirmaLogService } from 'src/app/_services/client-firma-log.service';
import { ProcedimientosService } from "src/app/_services/procedimientos.service";
import { ServicioGeneral } from "src/app/_services/servicio-general.service";
import { SolicitudEmvsService } from "src/app/_services/solicitud-emvs.service";
import { TokenStorageService } from "src/app/_services/token-storage.service";
import { UserService } from "src/app/_services/user.service";
import { environment } from "src/environments/environment";
import { NavService } from "../../boton-listado/boton-listado.component.service";
import { ListadoTramitesEmvsService } from "../../listado/listado-tramites-emvs/listado-tramites-emvs.service";
import { ConfirmDeleteDialogComponent } from "../../modal/confirm-delete/confirm-delete-dialog.component";
import {
  EstadoTramite,
  TramiteEmvs
} from "../../listado/listado-tramites-emvs/tramite-emvs";
import { DenominacionPuestoElement } from "../../model/denominacionpuesto";
import { OrdenConvocatoriaElement } from "../../model/ordenconvocatoria";
import { PuestoEmvs, SolicitudPuesto } from "../../model/puestoEmvs";

import { MatDialog } from "@angular/material/dialog";
import { MatLegacyDialog as MatLegacyDialog } from "@angular/material/legacy-dialog";
import { DialogGenericComponent } from "src/app/modal/dialog-generic/dialog-generic.component";
import { ClaveService } from "../../_services/clave.service";
import { NotificationI18nService } from '../../core/util/notification-i18n.service';
import { SamlRequest } from "../../model/samltoken";

(pdfMake as any).vfs = pdfFonts.pdfMake.vfs;

declare const AutoScript: any;
declare const Constants: any;

@Component({
  selector: "app-tramite-spv",
  templateUrl: "./tramite-spv.component.html",
  styleUrls: ["./tramite-spv.component.scss"],
})
export class TramiteSPVComponent extends UnsubscribeOnDestroy implements OnInit, OnDestroy {

  procedimiento: any = {};
  numeroRegistro: string;
  currentEnv = environment.environment;
  interested: any = {};
  currentUser: any = this.tokenStorageService.getUser();
  TProvincias: any = [];
  TMunicipios: any = [];
  estadosCiviles: any = [];
  parentescos: string[] = [
    "SOLICITANTE",
    "PADRE/MADRE",
    "ESPOSO/A",
    "NOVIO/A",
    "HIJO/A",
    "ABUELO/A",
    "NIETO/A",
    "OTROS/AS",
    "YERNO/NUERA",
    "HERMANO/A",
    "CUÑADO/A",
    "PAREJA DE HECHO",
    "ACOGIMIENTO LEGAL"
  ];
  tipoFicherosPermitiros: any[] = ["application/pdf", "application/vnd.rar", "application/x-rar-compressed", "application/octet-stream", "application/x-zip-compressed", "image/jpg", "image/jpeg", "image/png", "application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"];
  zonas: string[] = ["centro", "arganzuela", "retiro", "salamanca", "chamartin", "tetuan", "chamberi", "fuencarral_pardo", "moncloa", "latina", "carabanchel", "usera", "puente_vallecas", "moratalaz", "ciudad_lineal", "hortaleza", "villaverde", "vallecas_villa", "vilcalvaro", "san_blas", "barajas"];
  gradosDiscapacidad: any = [];
  gradosDependencia: any = [];
  procedimientosVisibles: any = [];
  solicitudId: string = "";
  representanteId: string = "";
  circustanciaId: string = "";
  unidadId: string;
  activeAddress: any = {};
  municipios: any = this._servicioGeneral.getMunicipios();
  user: any = this._servicioUsuario.getCurrentUserFromServer();
  municipioNombre: string = "";
  submitted: boolean = false;
  private _isSubmittingFamiliar: boolean = false;
  isLogged: boolean = false;
  restauraPestania: boolean = true;
  genero: string = "";
  numerodocumento: string = "";
  lopd: string = "";
  lastVisitedTab: string = "";
  provincias = this._servicioGeneral.getProvincias();
  ordenConvocatoria: OrdenConvocatoriaElement[] = [];
  denominacionPuesto: DenominacionPuestoElement[] = [];
  arrayAuxPuestos: DenominacionPuestoElement[] = [];
  nombreFilePuesto1: string = "";
  nombreFilePuesto2: string = "";
  submitPuestos: boolean = false;
  submitFamiliar: boolean = false;
  familiarActivo: number = 0;
  autorizacionActivo: number = 0;
  submitAutorizacion: boolean = false;
  submitRepresentante: boolean = false;
  submitInstancia: boolean = false;
  submitConsulta: boolean = false;
  isSigning: boolean = false;
  faltaFirma: boolean = false;
  mapDocumentos: any[] = [];
  arrayFicheros: any[] = [];
  uploadDocuments: boolean = false;
  firmaResultLocked = false;
  TVias: any = [];
  displayAvisoFirma: string = "none";
  tramite: TramiteEmvs = {
    id: -1,
  };
  mensajeSpinner: string = "Subiendo documentos...";
  representante: any;
  idProcedimiento: number;
  //  @Input() botonListado?: BotonListado;

  selectedOpcion: String = "";
  tabsProcedure2: string[] = [
    "personales-tab",
    "circunstancias-tab",
    "unidad-tab",
    "consulta-tab",
    "autorizacion-tab"
  ];

  tabsComprobar: string[];
  tabRestoreBehavior = {
    "personales-tab": () => this.restorePersonales(),
    "circunstancias-tab": () => this.restoreCircustancias(),
    "unidad-tab": () => this.restoreUnidad(),
    "consulta-tab": () => this.restoreConsulta(),
    "autorizacion-tab": () => this.restoreAutorizacion(),
  };
  displayFirma: string = 'none';
  procedimientoId: number = 0;
  actionProgres: boolean = false;
  isInProgress: boolean = false;
  autorizacionId: number;
  documentosId: number;
  puestoModel: {
    id?: number;
    idDocumento1?: string;
    idDocumento2?: string;
  } = {};
  instanciaId: number;
  subscription: Subscription;
  CSV: any;
  userTk = this.tokenStorageService.getUser()
  isAdmin: boolean = Math.max(...this.userTk["rol"]) > 1;
  firmaDelete: boolean = false;
  firmaTramite: boolean = false;
  tramiteBloqueado: boolean = true;
  constructor(
    private tokenStorageService: TokenStorageService,
    private _servicioGeneral: ServicioGeneral,
    private _servicioUsuario: UserService,
    private _notificationI18n: NotificationI18nService,
    private _solicitudEmvsService: SolicitudEmvsService,
    private _router: Router,
    private _serviceProcedimientos: ProcedimientosService,
    private _route: ActivatedRoute,
    private listadoTramitesService: ListadoTramitesEmvsService,
    private _navService: NavService,
    private spinner: NgxSpinnerService,
    private _claveService: ClaveService,
    public dialog: MatDialog,
    private deleteDialog: MatLegacyDialog,
    private _clientFirmaLog: ClientFirmaLogService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.lastVisitedTab = "";
    this.idProcedimiento = Number(this._route.snapshot.paramMap.get("id"));
    this.isLogged = !!this.tokenStorageService.getToken();

    if (!this.isLogged) {
      this._router.navigate(["/login"]);
      return;
    }

    if (!Number.isFinite(this.idProcedimiento) || this.idProcedimiento <= 0) {
      this._router.navigate(["perfil"], { queryParams: { action: 30 } });
      return;
    }
    this.getProcedimiento();
    this.getNombreMunicipio();
    this.getProvincias();
    this.genero = this.currentUser.genero;
    this.numerodocumento = this.currentUser.numero_documento;
    if (this.currentUser.genero) {
      this.formTramite.controls["genero"].patchValue(
        this.genero,
        { emitEvent: false }
      );
    }
    this.getTramiteByUserId(this.idProcedimiento);
    this.checkNoExisteTramite();
    this.tabsComprobar = this.tabsProcedure2;

    this._solicitudEmvsService.getPoliticas(2)
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        if (data != null) {
          this.lopd = data["data"];
        }
      });
    this.subscription = this._navService.navItem$
      .pipe(takeUntil(this.destroy$))
      .subscribe((item) => {
        this.selectedOpcion = item;
        this.downloadJustificanteFrontP();
      });
  }
  override ngOnDestroy() {
    super.ngOnDestroy();
  }

  ngAfterViewChecked() {
    if (this.listadoTramitesService.tramite && this.solicitudId == "") {
      if (bloquearSiTramiteDadoDeBaja(
        this.listadoTramitesService.tramite.estadoFirma,
        this._router,
        this._notificationI18n,
        true
      )) {
        this.listadoTramitesService.tramite = null;
        return;
      }
      const procRestaurado = Number(
        this.listadoTramitesService.tramite?.procedimiento_id?.id
      );
      if (
        !Number.isFinite(procRestaurado) ||
        procRestaurado !== Number(this.idProcedimiento)
      ) {
        console.warn(
          "Descartando trámite restaurado por procedimiento_id no coincidente",
          { esperado: this.idProcedimiento, recibido: procRestaurado }
        );
        this.listadoTramitesService.tramite = null;
        return;
      }
      this.lastVisitedTab = this.listadoTramitesService.tramite.lastVisitedTab;
      if (
        document.getElementById(
          this.listadoTramitesService.tramite.lastVisitedTab
        ) &&
        !document
          .getElementById(this.listadoTramitesService.tramite.lastVisitedTab)
          .classList.contains("active")
      ) {
        this.tramite = this.listadoTramitesService.tramite;
        this._notificationI18n.success('NOTIFICATION.MESSAGE.TRAMITE_RECUPERADO_CON_EXITO');
        this.solicitudId = this.listadoTramitesService.tramite.id.toString();
        this.tabRestoreBehavior[
          this.listadoTramitesService.tramite.lastVisitedTab
        ]();
        this.enableAutoSave();
        document
          .getElementById(this.listadoTramitesService.tramite.lastVisitedTab)
          .classList.remove("disabled");
        this.restauraPestania = false;
        document
          .getElementById(this.listadoTramitesService.tramite.lastVisitedTab)
          .click();
        document
          .getElementById(this.listadoTramitesService.tramite.lastVisitedTab)
          .classList.add("disabled");
        this.listadoTramitesService.tramite = null;
        this._route.queryParams
          .pipe(takeUntil(this.destroy$))
          .subscribe((params) => {
            const rId = params["rId"];
            const accion = params["a"];
            if (rId && accion) {
              this.pdfProcedimientoClave(rId, accion);
            }
            this.numeroRegistro = params["numeroRegistro"];
          });
      }
    }
  }

  formTramite: FormGroup = new FormGroup({
    procedimiento_id: new FormControl(""),
    genero: new FormControl("", Validators.required),
    tramite_id: new FormControl(""),
    telefono2: new FormControl("", Validators.pattern('^([9,7,6]{1}[0-9]{8})')),
    telefono3: new FormControl("", Validators.pattern('^([9,7,6]{1}[0-9]{8})')),
    numeroRegistro: new FormControl(""),
    sobreescribeTramitePrevio: new FormControl(false),
  });

  formPoliticas: FormGroup = new FormGroup({
    politicas: new FormControl("", Validators.required),
  });

  formCircunstancias: FormGroup = new FormGroup({
    tramite: new FormControl(""),
    pregunta1: new FormControl("", Validators.required),
    pregunta2: new FormControl("", Validators.required),
    pregunta3: new FormControl("", Validators.required),
    pregunta4: new FormControl("", Validators.required),
    pregunta5: new FormControl("", Validators.required),
    pregunta6: new FormControl("", Validators.required),
    pregunta7: new FormControl("", Validators.required),
    pregunta8: new FormControl("", Validators.required),
  });
  formUnidadFamiliar: FormGroup = new FormGroup({
    familiar: new FormArray([
      new FormGroup({
        documento: new FormControl(this.currentUser.numero_documento, [
          Validators.pattern(/^([0-9]{8}[A-Z]|[XYZ][0-9]{7}[A-Z])$/i),
        ]),
        nombre: new FormControl(
          this.currentUser.nombre,
          [Validators.required, Validators.maxLength(30)]
        ),
        primerApellido: new FormControl(
          this.currentUser.apellido1,
          [Validators.required, Validators.maxLength(60)]
        ),
        segundoApellido: new FormControl(
          this.currentUser.apellido2,
          Validators.maxLength(60)
        ),
        fecha_nacimiento: new FormControl("", [Validators.required, fechaMinimaValidator(new Date(1920, 0, 1))]),
        parentesco: new FormControl("SOLICITANTE", Validators.required),
        estado_civil: new FormControl("", Validators.required),
        grado_discapacidad: new FormControl("", Validators.required),
        grado_dependencia: new FormControl("", Validators.required),
        tramite: new FormControl(""),
      }, { validators: documentoSegunEdadValidator() }),
    ]),
  });


  checkDistritos: ValidatorFn = (
    group: AbstractControl
  ): ValidationErrors | null => {
    if (group.get("todas_zonas").value == true) {
      return null;
    } else if (
      group.get("centro").value != "" ||
      group.get("arganzuela").value != "" ||
      group.get("retiro").value != "" ||
      group.get("salamanca").value != "" ||
      group.get("chamartin").value != "" ||
      group.get("tetuan").value != "" ||
      group.get("chamberi").value != "" ||
      group.get("fuencarral_pardo").value != "" ||
      group.get("moncloa").value != "" ||
      group.get("latina").value != "" ||
      group.get("carabanchel").value != "" ||
      group.get("usera").value != "" ||
      group.get("puente_vallecas").value != "" ||
      group.get("moratalaz").value != "" ||
      group.get("ciudad_lineal").value != "" ||
      group.get("hortaleza").value != "" ||
      group.get("villaverde").value != "" ||
      group.get("vallecas_villa").value != "" ||
      group.get("vilcalvaro").value != "" ||
      group.get("san_blas").value != "" ||
      group.get("barajas").value != ""
    ) {
      if (group instanceof FormGroup) {
        var values: Array<number> = [];
        this.zonas.forEach(element => {
          if (group.get(element)?.value) values.push(+(group.get(element)!.value));
        });

        const hasDuplicates = values.some((value, index) => {
          return values.indexOf(value) !== index;
        });
        if (hasDuplicates)
          return { duplicateValues: true };

        const maxMinVal = values.some((value) => {
          return value < 1 || value > 21;
        });
        if (maxMinVal)
          return { minMaxValues: true };
      }
      return null;
    } else {
      return { required: true };
    }
  };

  formAutorizacion: FormGroup = new FormGroup({
    autorizacion: new FormArray([
      new FormGroup({
        tramite: new FormControl(""),
        documento: new FormControl(this.currentUser.numero_documento, [
          Validators.required,
          Validators.pattern(/^([0-9]{8}[A-Z]|[XYZ][0-9]{7}[A-Z])$/i),
        ]),
        nombre: new FormControl(
          this.currentUser.nombre,
          [Validators.required, Validators.maxLength(30)]
        ),
        primerApellido: new FormControl(
          this.currentUser.apellido1,
          [Validators.required, Validators.maxLength(60)]
        ),
        segundoApellido: new FormControl(
          this.currentUser.apellido2,
          Validators.maxLength(60)
        ),
        fecha_nacimiento: new FormControl("", [Validators.required, fechaMinimaValidator(new Date(1920, 0, 1))]),
        estado_civil: new FormControl("", Validators.required),
        parentesco: new FormControl("Solicitante", Validators.required),
        send_request_accept: new FormControl(),
      }),
    ],
      [minLengthArray(1)]
    ),
  });


  formPuestos: FormGroup = new FormGroup({
    documento: new FormControl("", [Validators.required]),
    documento2: new FormControl("", [Validators.required]),
    check1: new FormControl(""),
    puesto: new FormArray([
      new FormGroup({
        convocatoria: new FormControl(""),
        denominacion: new FormControl("", [Validators.required]),
      }),
    ]),
  });

  formInstancia: FormGroup = new FormGroup({
    tramite: new FormControl(""),
    expone: new FormControl("", Validators.required),
    solicita: new FormControl("", Validators.required),
  });
  formDeclaracionResponsable: FormGroup = new FormGroup({
    tramite: new FormControl(""),
    declaracion: new FormControl("", Validators.required)
  });
  // formProteccion: FormGroup = new FormGroup({
  //   proteccion: new FormControl("")
  // })

  formatDate(date) {
    const dateFormat = new Date(date);
    let month = "" + (dateFormat.getMonth() + 1);
    let day = "" + dateFormat.getDate();
    let year = dateFormat.getFullYear();
    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;
    return [year, month, day].join("-");
  }

  private getUsuario(): void {
    this.currentUser = this.tokenStorageService.getUser();
    if (this.currentUser.email == null) {
      this._router.navigateByUrl("/perfil?action=20");
      this._notificationI18n.warning('NOTIFICATION.MESSAGE.DEBE_COMPLETAR_LOS_DATOS_DE_SU_PERFIL_PARA_PODER_REALIZAR_TRAMITES');
    } else if (this.currentUser.email_confirmado == false) {
      this._router.navigateByUrl("/perfil?action=20");
      this._notificationI18n.warning('NOTIFICATION.MESSAGE.DEBE_VERIFICAR_CUENTA_CORREO');
    }
    this.currentUser.direcciones.forEach((element) => {
      if (element.isActive) {
        this.activeAddress = element;
      }
    });
    this.searchUser(this.currentUser.id);
  }

  private getProcedimiento(): void {
    this._serviceProcedimientos
      .getProcedimiento(this.idProcedimiento)

      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (procedimiento) => {
          if (bloquearSiProcedimientoNoActivo(procedimiento, this._router, this._notificationI18n, this.isAdmin)) {
            this.tramiteBloqueado = true;
            return;
          }
          this.procedimiento = procedimiento["Procedimiento"];
        },
        error: (error) => {
          //console.log(error);
        },
      });
    this.getUsuario();
  }

  getTramiteByUserId(idProcedimiento: number) {
    if (!Number.isFinite(idProcedimiento) || idProcedimiento <= 0) {
      this.tramiteBloqueado = true;
      this._router.navigate(["perfil"], { queryParams: { action: 30 } });
      return;
    }

    this.tramiteBloqueado = true;
    this.mostrarSpinnerMsg("Validando trámites previos...");

    this.listadoTramitesService
      .checkTramitePendienteFirma(idProcedimiento)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (resp) => {
          if (resp?.pendienteFirma) {
            this.ocultarSpinner();
            this._notificationI18n.warning('NOTIFICATION.MESSAGE.YA_EXISTE_UN_TRAMITE_EN_CURSO_PARA_ESTE_PROCEDIMIENTO_FINALICELO_O_SOLICITE_SU_E', 5000);
            this._router.navigate(["perfil"], {
              queryParams: { action: 30 },
            });
            return;
          }
          this.restaurarTramiteNoFinalizado(idProcedimiento);
        },
        error: (error) => {
          console.error("Error validando trámites pendientes de firma", error);
          this.ocultarSpinner();
          this._notificationI18n.error('NOTIFICATION.MESSAGE.NO_SE_HA_PODIDO_VALIDAR_LA_EXISTENCIA_DE_TRAMITES_PREVIOS_INTENTELO_DE_NUEVO_MAS');
          this._router.navigate(["perfil"], { queryParams: { action: 30 } });
        },
      });
  }

  private restaurarTramiteNoFinalizado(idProcedimiento: number) {
    this.listadoTramitesService
      .getTramitesByuserId(this.currentUser.id)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {
          const noFinalizado = (data ?? []).find(
            (it) =>
              it?.usuario_id?.id != null &&
              Number(it.usuario_id.id) === Number(this.currentUser.id) &&
              it?.procedimiento_id?.id != null &&
              Number(it.procedimiento_id.id) === Number(idProcedimiento) &&
              !it.custom &&
              it.estadoFirma === "NO_FINALIZADO"
          );
          if (noFinalizado) {
            this.listadoTramitesService.tramite = noFinalizado;
          }
          this.tramiteBloqueado = false;
          this.ocultarSpinner();
        },
        error: (error) => {
          console.error("Error recuperando trámites no finalizados", error);
          this.tramiteBloqueado = false;
          this.ocultarSpinner();
        },
      });
  }

  getNombreMunicipio(): void {
    this._servicioGeneral
      .getNombreMunicipio(
        this.activeAddress.province.id,
        this.activeAddress.municipality
      )

      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {
          return (this.municipioNombre = data.nombre);
        },
        error: (error) => {
          //console.log(error);
        },
      });
  }

  searchUser(id: number): void {
    this._servicioGeneral.getUserId(id)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {
          this.currentUser = data.Usuario;
          this.tokenStorageService.setUser(data.Usuario, data.usuarioRepresenta);
        },
        error: (error) => {
          //console.log(error);
        },
      });
  }

  getProvincias() {
    return this._servicioGeneral.getProvincias()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.TProvincias = data["Provincia"];
      });
  }

  onChangeProvincia(event: Event) {
    this.TProvincias = [];
    const id = (event.target as HTMLInputElement).value;
    this.getProvinciasByID(id);
  }

  getProvinciasByID(id: string) {
    this.provincias
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        data["Provincia"].forEach((provincia) => {
          if (provincia.ccaa["id"] == id) {
            this.TProvincias.push(provincia);
            return this.TProvincias;
          }
        });
      });
  }

  onChangeMunicipio(event: Event) {
    this.TMunicipios = [];
    const id = (event.target as HTMLInputElement).value;
    this.getMunicipiosByID(id);
  }

  getMunicipiosByID(id: string) {
    this.municipios
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        data["Municipio"].forEach((municipio) => {
          if (municipio.municipioPK["provincia"] == id) {
            this.TMunicipios.push(municipio);
            return this.TMunicipios;
          }
        });
      });
  }

  getVias() {
    return this._servicioGeneral.getTipoVias()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.TVias = data["TipoVia"];
      });
  }

  getProcedimientos() {
    return this._serviceProcedimientos.getProcedimientos()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {
          this.procedimientosVisibles = data["Procedimiento"];
        },
        error: (err) => {
          //console.log(err);
        },
      });
  }

  getEstadoCivil() {
    return this._servicioGeneral.getEstadoCivil()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {
          this.estadosCiviles = data["estados_civiles"];
        },
        error: (err) => {
          //console.log(err);
        },
      });
  }

  getGradoDiscapacidad() {
    return this._servicioGeneral.getGradoDiscapacidad()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {
          this.gradosDiscapacidad = data["grados_discapacidad"];
        },
        error: (err) => {
          //console.log(err);
        },
      });
  }

  getGradoDependencia() {
    return this._servicioGeneral.getGradoDependencia()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {
          this.gradosDependencia = data["grados_dependencia"];
        },
        error: (err) => {
          //console.log(err);
        },
      });
  }

  getOrdenConvocatoria() {
    return this._solicitudEmvsService.getOrdenConvocatoria()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {
          this.ordenConvocatoria = data.orden_convocatoria;
        },
        error: (err) => {
          //console.log(err);
        },
      });
  }

  getDenominacionPuesto() {
    return this._solicitudEmvsService.getDenominacionPuesto()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {
          this.denominacionPuesto = data.denominacion_puesto;
        },
        error: (err) => {
          //console.log(err);
        },
      });
  }

  onSubmitTramite(): any {
    this.submitted = true;

    if (this.tramiteBloqueado) {
      this._notificationI18n.warning('NOTIFICATION.MESSAGE.ESTAMOS_VALIDANDO_SUS_TRAMITES_PREVIOS_ESPERE_UNOS_SEGUNDOS_ANTES_DE_CONTINUAR', 5000);
      return false;
    }

    if (!this.formTramite.valid) {
      this._notificationI18n.warning('NOTIFICATION.MESSAGE.RELLENE_TODOS_LOS_CAMPOS_POR_FAVOR', 5000);
      return false;
    }
    this.formTramite.controls["procedimiento_id"].patchValue(
      this.procedimiento.id,
      { emitEvent: false }
    );
    if (this.solicitudId != null && this.solicitudId != undefined) {
      this.formTramite.controls["tramite_id"].patchValue(this.solicitudId, {
        emitEvent: false,
      });
    }
    else {
      this.formTramite.controls["numeroRegistro"].patchValue(
        this.procedimiento.id,
        { emitEvent: false }
      );
    }
    this._solicitudEmvsService.saveTramite(this.formTramite.value)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: async (data) => {
          this.solicitudId = data.tramite.id;
          this.tramite = data.tramite;
          this.currentUser = data.tramite.usuario_id;
          this.searchUser(data.tramite.usuario_id.id);

          this.siguiente();
        },
        error: (err) => {
          if (err?.status === 409) {
            this.tramiteBloqueado = true;
            const mensaje = err?.error?.responseError ??
              "Ya existe un trámite en curso para este procedimiento. Finalícelo o solicite su eliminación antes de iniciar uno nuevo.";
            this._notificationI18n.infoDynamic(mensaje, 5000);
            this._router.navigate(["perfil"], { queryParams: { action: 30 } });
          } else {
            console.error("Error guardando el trámite", err);
            this._notificationI18n.error('NOTIFICATION.MESSAGE.NO_SE_HA_PODIDO_GUARDAR_EL_TRAMITE_INTENTELO_DE_NUEVO');
          }
        },
      });


    this.enableAutoSave();
  }


  onSubmitCircunstancias(): any {
    // this.submitted = true;

    if (!this.formCircunstancias.valid) {
      this._notificationI18n.warning('NOTIFICATION.MESSAGE.CONTESTE_TODAS_LAS_PREGUNTAS', 5000);
      return false;
    } else {
      this.formCircunstancias.controls["tramite"].patchValue(
        { id: this.solicitudId },
        { emitEvent: false }
      );

      this._solicitudEmvsService
        .saveCircunstanciasEmvs({
          ...this.formCircunstancias.value,
          id: this.circustanciaId,
        })

        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: async (data) => {
            this.restoreValuesUnidad();
            this.circustanciaId = data["id"];
            this.siguiente();
          },
        });
    }
  }

  onSubmitUnidadFamiliar(): any {
    this._isSubmittingFamiliar = true;
    this.autorizacion.clear({ emitEvent: false });
    let form: any = this.formAutorizacion.controls["autorizacion"];
    form.clear({ emitEvent: false });
    this.submitFamiliar = true;

    let dniDuplicado = false;
    const dnis = new Set<string>();

    for (let [index, control] of this.formUnidadFamiliar.get("familiar")["controls"].entries()) {
      const dni = control["controls"]["documento"]?.value ?? '';
      control["controls"]["documento"]?.markAsTouched();
      control["controls"]["documento"]?.markAsDirty();
      control["controls"]["documento"]?.updateValueAndValidity();
      if (dni?.trim()) {
        if (dnis.has(dni.toUpperCase())) {
          dniDuplicado = true;
          break;
        }
        dnis.add(dni.toUpperCase());
      }
    }
    if (dniDuplicado) {
      this._notificationI18n.warning('NOTIFICATION.MESSAGE.EL_NUMERO_DE_DOCUMENTACION_NO_PUEDE_REPETIRSE_EN_LA_UNIDAD_FAMILIAR', 5000);
      this._isSubmittingFamiliar = false;
      return false;
    }
    if (!this.familiar.valid) {
      this._notificationI18n.warning('NOTIFICATION.MESSAGE.RELLENE_TODOS_LOS_CAMPOS_CORRECTAMENTE_POR_FAVOR', 5000);
      this._isSubmittingFamiliar = false;
      return false;
    } else if (!this.checkSolicitantMayorEdad()) {
      this._notificationI18n.warning('NOTIFICATION.MESSAGE.EL_SOLICITANTE_DEBE_SER_MAYOR_DE_EDAD', 5000);
      this._isSubmittingFamiliar = false;
      return false;
    } else {
      for (let control of this.formUnidadFamiliar.get("familiar")["controls"]) {
        control["controls"]["tramite"].patchValue(
          { id: this.solicitudId },
          { emitEvent: false }
        );

        let estadoCivil = this.estadosCiviles.find(
          (value) => value.id == control["controls"]["estado_civil"].value
        );
        control["controls"]["estado_civil"].setValue(
          {
            id: estadoCivil.id,
            nombre: estadoCivil.nombre,
          },
          { emitEvent: false }
        );

        if (
          control["controls"]["grado_discapacidad"]?.value
            ?.toString()
            .match("[0-9]{1,2}")
        ) {
          control["controls"]["grado_discapacidad"].setValue(
            {
              id: control["controls"]["grado_discapacidad"].value,
              nombre: this.gradosDiscapacidad.find(
                (value) =>
                  value.id == control["controls"]["grado_discapacidad"].value
              ).nombre,
            },
            { emitEvent: false }
          );
        }
        if (
          control["controls"]["grado_dependencia"]?.value
            ?.toString()
            .match("[0-9]{1,2}")
        ) {
          control["controls"]["grado_dependencia"].setValue(
            {
              id: control["controls"]["grado_dependencia"].value,
              nombre: this.gradosDependencia.find(
                (value) =>
                  value.id == control["controls"]["grado_dependencia"].value
              ).nombre,
            },
            { emitEvent: false }
          );
        }

        form.push(
          new FormGroup({
            tramite: new FormControl(control["controls"]["tramite"].value),
            documento: new FormControl(control["controls"]["documento"].value, [
              Validators.required,
              Validators.pattern(/^([0-9]{8}[A-Z]|[XYZ][0-9]{7}[A-Z])$/i),
            ]),
            nombre: new FormControl(
              control["controls"]["nombre"].value,
              [Validators.required, Validators.maxLength(30)]
            ),
            primerApellido: new FormControl(
              control["controls"]["primerApellido"].value,
              [Validators.required, Validators.maxLength(60)]
            ),
            segundoApellido: new FormControl(
              control["controls"]["segundoApellido"].value,
              Validators.maxLength(60)
            ),
            fecha_nacimiento: new FormControl(
              control["controls"]["fecha_nacimiento"].value,
              [Validators.required, fechaMinimaValidator(new Date(1920, 0, 1))]
            ),
            estado_civil: new FormControl(estadoCivil.id, Validators.required),
            parentesco: new FormControl(
              control["controls"]["parentesco"].value,
              Validators.required
            ),
            send_request_accept: new FormControl(),
          }),
          { emitEvent: false }
        );
      }

      if (this.familiar && this.familiar.value) {
        this._solicitudEmvsService
          .saveUnidadFamiliar(this.familiar.value)

          .pipe(takeUntil(this.destroy$))
          .subscribe({
            next: () => {
              this.saveAutorizacionDerivada(
                () => {
                  this._isSubmittingFamiliar = false;
                  this.siguiente();
                },
                () => {
                  this._isSubmittingFamiliar = false;
                }
              );
            },
            error: (error) => {
              this._isSubmittingFamiliar = false;
              if (error && error.error && (error.error.responseError || error.error.message)) {
                this._notificationI18n.errorDynamic(error.error.responseError ?? error.error.message, 5000);
              }
            }
          });
      } else {
        this._isSubmittingFamiliar = false;
      }
    }
  }

  private saveAutorizacionDerivada(onSuccess?: () => void, onError?: () => void): void {
    if (!this.autorizacion || this.autorizacion.length === 0) {
      onSuccess?.();
      return;
    }
    const autorizacionesToSave = this.autorizacion.value.map((item: any) => {
      const copy = { ...item, tramite: { id: this.solicitudId } };
      const valorEstadoCivil = copy.estado_civil;
      const estadoCivil = this.estadosCiviles.find(
        (value) => value.id == valorEstadoCivil || value.nombre == valorEstadoCivil
      ) ?? this.estadosCiviles[0];
      if (estadoCivil) {
        copy.estado_civil = { id: estadoCivil.id, nombre: estadoCivil.nombre };
      }
      return copy;
    });
    this._solicitudEmvsService
      .saveAutorizacion(autorizacionesToSave)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (autorizacion: any) => {
          for (let [index, control] of this.formAutorizacion
            .get("autorizacion")
          ["controls"].entries()) {
            if (!control["controls"]["id"] && autorizacion?.[index]?.id) {
              control.addControl("id", new FormControl(""), { emitEvent: false });
              control["controls"]["id"].patchValue(autorizacion[index].id, { emitEvent: false });
            }
          }
          onSuccess?.();
        },
        error: (error) => {
          if (error && error.error && (error.error.responseError || error.error.message)) {
            this._notificationI18n.errorDynamic(error.error.responseError ?? error.error.message, 5000);
          }
          onError?.();
        }
      });
  }

  onSubmitAutorizacionCheck(): any {
    if (!this.autorizacion.valid) {
      this._notificationI18n.warning('NOTIFICATION.MESSAGE.RELLENE_TODOS_LOS_CAMPOS_POR_FAVOR', 5000);
      return false;
    } else {
      if (this.mayorDeEdadSinConsentimiento()) {
        this.displayAvisoFirma = "block";
      }
      else {
        this.onSubmitAutorizacion();
      }

    }
  }
  closeAvisoFirmaModal(): any {
    this.displayAvisoFirma = "none";
  }
  onSubmitAutorizacion(): any {
    var isValidNIFs = true;

    if (!validaNifsForm(this.formAutorizacion.get("autorizacion")["controls"].entries()) || !validaNifsForm(this.formUnidadFamiliar.get("familiar")["controls"].entries())) {
      this._notificationI18n.warning('NOTIFICATION.MESSAGE.ALGUNO_DE_LOS_DATOS_DE_LOS_INTEGRANTES_DE_LA_UNIDAD_FAMILIAR_NO_TIENE_UN_FORMATO', 5000);
      return false;
    }

    this.displayAvisoFirma = "none";
    this.submitAutorizacion = true;
    if (!this.autorizacion.valid) {
      this._notificationI18n.warning('NOTIFICATION.MESSAGE.RELLENE_TODOS_LOS_CAMPOS_POR_FAVOR', 5000);
      return false;
    } else {
      for (let control of this.formAutorizacion.get("autorizacion")[
        "controls"
      ]) {
        control["controls"]["tramite"].patchValue(
          { id: this.solicitudId },
          { emitEvent: false }
        );
      }
      const autorizacionesToSave = this.autorizacion.value.map((item: any) => {
        const copy = { ...item };
        const valorEstadoCivil = copy.estado_civil;
        if (!valorEstadoCivil?.toString().match("[0-9]{1,2}")) {
          let estadoCivil = this.estadosCiviles.find(
            (value) => value.nombre == valorEstadoCivil
          );
          if (estadoCivil) {
            copy.estado_civil = { id: estadoCivil.id, nombre: estadoCivil.nombre };
          }
        } else {
          let estadoCivil = this.estadosCiviles.find(
            (value) => value.id == valorEstadoCivil
          );
          if (estadoCivil) {
            copy.estado_civil = { id: estadoCivil.id, nombre: estadoCivil.nombre };
          }
        }
        return copy;
      });
      this._solicitudEmvsService
        .saveAutorizacion(autorizacionesToSave)

        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: async (data) => {
            //this.siguiente();
            this.uploadDocuments = true;
            this.getEstadoCivil();
            if (this.currentUser.fechaNacimiento) {
              if (this.selectedOpcion == "Firmar con Autofirma") {
                this.mostrarSpinnerMsg("Solicitando firma...");
                this._servicioGeneral.generatePdf(this.tramite.id)
                  .pipe(takeUntil(this.destroy$))
                  .subscribe({
                    next: async (data: any) => {
                      if (isGeneratePdfReady(data)) {
                        this.CSV = data.csv;
                        this.firmaDelete = false;
                        this.firmaTramite = true;
                        this._clientFirmaLog.iniciada(this.solicitudId, 'tramite-spv');
                        this.singFile(data.file);
                      }
                      else {
                        this._notificationI18n.errorPdfGeneration(data, 5000);
                        this.ocultarSpinner();
                      }
                    },
                    error: (error) => {
                      if (error && error.error && error.error.responseError) {
                        this._notificationI18n.error(
                          "Ha ocurrido un error actualizando el estado del trámite.",
                          error.error.responseError,
                          5000
                        );
                      }
                      else {
                        this._notificationI18n.error('NOTIFICATION.MESSAGE.NO_HA_SIDO_POSIBLE_GENERAR_EL_DOCUMENTO_PARA_FIRMAR', 5000);
                      }
                      this.ocultarSpinner();
                    },
                  });
              } else {
                this._claveService.iniciaFirma(this.tramite.id, 1)
                  .pipe(takeUntil(this.destroy$))
                  .subscribe({
                    next: async (data: SamlRequest) => {
                      this.post(data.nodeService, {
                        SAMLRequest: data.SamlRequest,
                        RelayState: data.RelayState,
                      });
                    },
                    error: (error) => console.error(error),
                  });
              }
            }
            this.uploadDocuments = false;
          },
        });
    }
  }

  onSubmitConsulta(): any {
    this.submitConsulta = true;

    let lopdChecked = this.formDeclaracionResponsable.controls["declaracion"].value

    if (!lopdChecked) {
      this.submitConsulta = false;
      this._notificationI18n.warning('NOTIFICATION.MESSAGE.NO_ES_POSIBLE_CONTINUAR_SIN_ACEPTAR_LA_DECLARACION_RESPONSABLE', 5000);
      return false;
    } else {

      this.formDeclaracionResponsable.controls["tramite"].patchValue(
        { id: this.solicitudId },
        { emitEvent: false }
      );
      this.siguiente();
    }
  }



  onFileChangeFicheros(event, key: string, documento: string) {
    const file = event.target.files[0];
    if (file.size > 15728640) {
      this._notificationI18n.error('NOTIFICATION.MESSAGE.EL_ARCHIVO_SUPERA_LOS_15MB', 5000);
    }
    else if ((!file.type && !file.name.endsWith('.rar')) || (this.tipoFicherosPermitiros.findIndex(x => x === file.type) < 0 && !file.name.endsWith('.rar'))) {

      this._notificationI18n.error('NOTIFICATION.MESSAGE.EL_ARCHIVO_NO_ES_TIENE_UN_FORMATO_VALIDO_LOS_FORMATOS_VALIDOS_SON_RAR_ZIP_JPG_PD', 5000);
    }
    else {
      this.convertFile(file)
        .pipe(takeUntil(this.destroy$))
        .subscribe((base64) => {
          let document = {
            key: key,
            nameDocument: event.target.files[0].name,
            typeDocument: event.target.files[0].type,
            b64Document: base64,
            tramite: this.solicitudId,
            id: this.documentosId,
          };
          let dataArrayfind = this.getMapaPrincipalByDni(documento);
          if (!dataArrayfind) {
            this.arrayFicheros.push({
              identificador: documento,
              documentos: [document],
            });
          } else {
            dataArrayfind["documentos"].push(document);
            this.arrayFicheros = this.arrayFicheros.map((mapa) => {
              if (mapa.identificador === documento) {
                return dataArrayfind;
              }
              return mapa;
            });
          }
        });
    }
  }

  getMapaPrincipalByDni(documento: string) {
    return this.arrayFicheros.find(
      (mapaPrincipal) => mapaPrincipal.identificador === documento
    );
  }

  onSubmitPoliticas(): any {
    //  this.botonListado.selectedOpcion;
    this.isSigning = true;
    this.uploadDocuments = true;
    let lopdChecked = this.formPoliticas.controls["politicas"].value;

    if (lopdChecked) {
    } else {
      this._notificationI18n.error('NOTIFICATION.MESSAGE.NO_PUEDE_FINALIZAR_EL_TRAMITE_SIN_ACEPTAR_LAS_POLITICAS', 5000);
      this.isSigning = false;
      this.uploadDocuments = false;
    }
  }

  onSubmitPuestos(): any {
    this.submitPuestos = true;

    if (!this.formPuestos.valid) {
      this._notificationI18n.warning('NOTIFICATION.MESSAGE.RELLENE_TODOS_LOS_CAMPOS_POR_FAVOR', 5000);
      return false;
    } else {
      if (
        this.formPuestos.controls["check1"].value == "" ||
        this.formPuestos.controls["check1"].value == "false"
      ) {
        this._notificationI18n.warning('NOTIFICATION.MESSAGE.ES_OBLIGATORIO_MARCAR_LA_CASILLA_DE_CONFIRMACION', 5000);
        return false;
      }

      this.uploadDocuments = true;
      let puestos: SolicitudPuesto[] = [];

      this.puesto.value.forEach((item) => {
        let denominacion;
        if (typeof item.denominacion === "object") {
          denominacion = item.denominacion;
        } else {
          denominacion =
            this.denominacionPuesto.find(
              (value) => value.id == item.denominacion
            ) ?? this.denominacionPuesto[0];
        }
        item.denominacion = {
          id: denominacion.id,
          nombre: denominacion.nombre,
          puesto: denominacion.puesto,
        };
        puestos.push(item);
      });

      let puestoEmvs = new PuestoEmvs(
        puestos,
        { id: this.solicitudId },
        this.puestoModel.id,
        this.puestoModel.idDocumento1,
        this.puestoModel.idDocumento2
      );
      this._solicitudEmvsService.savePuesto(puestoEmvs)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: async (data) => {
            const formData = new FormData();
            var campoDocumento1 =
              this.formPuestos.controls["documento"].value instanceof File
                ? "documento"
                : "idDocumento";
            var campoDocumento2 =
              this.formPuestos.controls["documento2"].value instanceof File
                ? "documento2"
                : "idDocumento2";

            formData.append(
              campoDocumento1,
              this.formPuestos.controls["documento"].value instanceof File
                ? this.formPuestos.controls["documento"].value
                : this.puestoModel?.idDocumento1
            );
            formData.append(
              campoDocumento2,
              this.formPuestos.controls["documento2"].value instanceof File
                ? this.formPuestos.controls["documento2"].value
                : this.puestoModel?.idDocumento2
            );
            formData.append("idPuesto", data.id);
            this._notificationI18n.info('NOTIFICATION.MESSAGE.SUBIENDO_DOCUMENTOS', 5000);
            this.mostrarSpinnerMsg("Subiendo documentos...");

            this._solicitudEmvsService.saveFilePuestos(formData)
              .pipe(takeUntil(this.destroy$))
              .subscribe({
                next: (data) => {
                  this.siguiente();
                  this.uploadDocuments = false;
                },
                error: (error) => {
                  this._notificationI18n.error('NOTIFICATION.MESSAGE.NO_SE_PUDIERON_SUBIR_LOS_ARCHIVOS_INTENTELO_DE_NUEVO_MAS_TARDE_POR_FAVOR', 5000);
                  this.ocultarSpinner();
                  this._router.navigate(["/inicio"]);
                },
              });
          },
        });
    }
  }

  onSubmitInstancia(): any {
    this.submitInstancia = true;

    if (!this.formInstancia.valid) {
      this._notificationI18n.warning('NOTIFICATION.MESSAGE.RELLENE_TODOS_LOS_CAMPOS_POR_FAVOR', 5000);

      return false;
    } else {
      this.uploadDocuments = true;
      this.formInstancia.controls["tramite"].patchValue(
        { id: this.solicitudId },
        { emitEvent: false }
      );

      //if(!this.faltaFirma){
      const solicitudEmvs = {
        ...this.formInstancia.value,
        id: this.instanciaId,
      };

      console.log(solicitudEmvs);

      this._solicitudEmvsService
        .saveInstancia({ ...this.formInstancia.value, id: this.instanciaId })

        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: async (data) => {
            console.log(data);

            if (this.mapDocumentos.length != 0) {
              this._notificationI18n.info('NOTIFICATION.MESSAGE.SUBIENDO_DOCUMENTOS', 5000);
              this.mostrarSpinnerMsg("Subiendo documentos...");
            }

            this.mapDocumentos.forEach((documento) => {
              documento["tramite"] = this.tramite.id;
            });

            console.log(this.mapDocumentos.length);

            this._solicitudEmvsService
              .saveDocumentosAdjuntos(
                this.mapDocumentos && this.mapDocumentos.length > 0
                  ? this.mapDocumentos
                  : [{ tramite: this.tramite.id }]
              )

              .pipe(takeUntil(this.destroy$))
              .subscribe({
                next: async (data) => {
                  this.uploadDocuments = false;

                  this.siguiente();
                },
                error: (error) => {
                  this._notificationI18n.error('NOTIFICATION.MESSAGE.NO_SE_PUDIERON_SUBIR_LOS_ARCHIVOS_POR_FAVOR_INTENTELO_DE_NUEVO_MAS_TARDE', 5000);
                  this.ocultarSpinner();
                  this._router.navigate(["/inicio"]);
                },
              });
          },
          error: (error) => {
            console.error(error);
          },
        });
    }
  }

  get puesto(): FormArray {
    return this.formPuestos.get("puesto") as FormArray;
  }

  get autorizacion(): FormArray {
    return this.formAutorizacion.get("autorizacion") as FormArray;
  }

  addPuesto() {
    this.puesto.push(
      new FormGroup({
        convocatoria: new FormControl(""),
        denominacion: new FormControl("", [Validators.required]),
      })
    );
  }

  deletePuesto() {
    this.puesto.removeAt(this.puesto.length - 1);
    this.addPuestoArray();
  }

  deleteFamiliar(index?: number) {
    const targetIndex = index ?? this.familiar.length - 1;
    if (targetIndex <= 0 || targetIndex >= this.familiar.length) {
      return;
    }
    const familiar = this.familiar.value[targetIndex];
    this.familiar.removeAt(targetIndex);
    if (this.familiarActivo >= this.familiar.length) {
      this.familiarActivo = Math.max(0, this.familiar.length - 1);
    }
    if (familiar?.id)
      this._solicitudEmvsService
        .deleteFamiliarById(familiar.id)

        .pipe(takeUntil(this.destroy$))
        .subscribe(() => { });
    if (familiar?.documento) {
      this.eliminarAutorizacionPorDocumento(familiar.documento);
    }
  }

  private eliminarAutorizacionPorDocumento(documento: string): void {
    for (let i = this.autorizacion.length - 1; i >= 0; i--) {
      if (this.autorizacion.at(i).get('documento')?.value === documento) {
        this.autorizacion.removeAt(i, { emitEvent: false });
      }
    }
    this._solicitudEmvsService
      .getAutorizacionByIdTramite(this.solicitudId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          const autorizaciones = response?.body || [];
          for (const autorizacion of autorizaciones) {
            if (autorizacion?.documento === documento && autorizacion?.id) {
              this._solicitudEmvsService
                .deleteAutorizacionById(autorizacion.id)
                .pipe(takeUntil(this.destroy$))
                .subscribe(() => { });
            }
          }
        }
      });
  }

  toggleFamiliar(i: number) {
    this.familiarActivo = this.familiarActivo === i ? -1 : i;
  }

  toggleAutorizacion(i: number) {
    this.autorizacionActivo = this.autorizacionActivo === i ? -1 : i;
  }

  deleteAutorizacion() {
    const autorizacion = this.autorizacion.value[this.autorizacion.length - 1];
    this.autorizacion.removeAt(this.autorizacion.length - 1);
    if (autorizacion?.id)
      this._solicitudEmvsService
        .deleteAutorizacionById(autorizacion.id)

        .pipe(takeUntil(this.destroy$))
        .subscribe(() => { });
  }



  get familiar(): FormArray {
    return this.formUnidadFamiliar.get("familiar") as FormArray;
  }

  addFamiliar() {
    this.familiar.push(
      new FormGroup({
        documento: new FormControl("", [
          Validators.pattern(/^([0-9]{8}[A-Z]|[XYZ][0-9]{7}[A-Z])$/i),
        ]),
        nombre: new FormControl("", [Validators.required, Validators.maxLength(60)]),
        primerApellido: new FormControl("", [Validators.required, Validators.maxLength(60)]),
        segundoApellido: new FormControl("", Validators.maxLength(60)),
        fecha_nacimiento: new FormControl("", [Validators.required, fechaMinimaValidator(new Date(1920, 0, 1))]),
        parentesco: new FormControl("", Validators.required),
        estado_civil: new FormControl("", Validators.required),
        grado_discapacidad: new FormControl("", Validators.required),
        grado_dependencia: new FormControl("", Validators.required),
        tramite: new FormControl(""),
      }, { validators: documentoSegunEdadValidator() })
    );
    this.familiarActivo = this.familiar.length - 1;
  }

  public singFile(data): void {
    try {
      AutoScript.cargarAppAfirma();
      AutoScript.setServlets(
        Constants.URL_BASE_SERVICES +
        "/afirma-signature-storage/StorageService",
        Constants.URL_BASE_SERVICES +
        "/afirma-signature-retriever/RetrieveService"
      );
      AutoScript.sign(
        data != undefined && data != null && data != "" ? data : null,
        "SHA256withRSA",
        "AUTO",
        "",
        this.successCallback,
        this.showErrorCallback
      );
    } catch (e) {
      this._clientFirmaLog.noDisponible(this.solicitudId, 'tramite-spv');
      this._notificationI18n.error('NOTIFICATION.MESSAGE.DEBES_DISPONER_DE_LA_APLICACION_AUTOFIRM_PARA_FIRMAR_LOS_TRAMITES_ADMINISTRATIVO');
    }
  }

  public successCallback = (filenameB64, certB64): void => {
    if (isFirmaSubmitLocked(this)) {
      return;
    }
    // filenameB64 es el nombre del fichero de firma codificado en Base 64
    (document.getElementById("certifcado") as HTMLInputElement).value = certB64;
    (document.getElementById("result") as HTMLInputElement).value = filenameB64;
    (document.getElementById("error") as HTMLInputElement).value = "";
    document.forms["firma"].dispatchEvent(
      new Event("submit", { cancelable: true, bubbles: true })
    );
  }
  public showErrorCallback = (errorType, errorMessage): void => {
    logAutofirmaError(this._clientFirmaLog, this.solicitudId, 'tramite-spv', errorType, errorMessage);
    if (isFirmaSubmitLocked(this)) {
      releaseFirmaSubmitLock(this);
      return;
    }
    (document.getElementById("certifcado") as HTMLInputElement).value = "";
    (document.getElementById('error') as HTMLInputElement).value = errorMessage + ". Se ha habilitado la opción para firmar con Cl@ve";
    document.forms["firma"].dispatchEvent(
      new Event("submit", { cancelable: true, bubbles: true })
    );
  }

  resultchange(event: Event): void {
    event.preventDefault();
    if (isFirmaSubmitLocked(this)) {
      return;
    }
    this.firmaResultLocked = true;

    let base64Document = (document.getElementById("result") as HTMLInputElement)
      .value;
    let errorFirma = (document.getElementById("error") as HTMLInputElement)
      .value;

    let certificado = atob(
      (document.getElementById("certifcado") as HTMLInputElement).value
    );

    if (
      certificado.includes(
        this.tokenStorageService.getUser().numero_documento
      ) ||
      certificado == ""
    ) {
      this.formDeclaracionResponsable.addControl("pdfFirmado", new FormControl(), {
        emitEvent: false,
      });
      if (this.firmaDelete) {
        this.pdfProcedimientoDelete(errorFirma, base64Document, this.formDeclaracionResponsable);
      }
      else if (this.firmaTramite) {
        this.pdfProcedimiento(errorFirma, base64Document, this.formDeclaracionResponsable);
      }
    } else {
      releaseFirmaSubmitLock(this);
      this.faltaFirma = true;
      this.isSigning = false;
      this.submitInstancia = false;
      this.submitConsulta = false;
      this._servicioUsuario
        .clearCurrentTipoFirma()

        .pipe(takeUntil(this.destroy$))
        .subscribe(() => { });
      this._clientFirmaLog.certificadoInvalido(this.solicitudId, 'tramite-spv');
      this._notificationI18n.error('NOTIFICATION.MESSAGE.EL_PDF_NO_SE_HA_PODIDO_FIRMAR_EL_CERTIFICADO_NO_COINCIDE_CON_EL_USUARIO');
    }
  }

  public pdfProcedimiento(
    errorFirma: string,
    base64Document: string,
    formDoc: FormGroup
  ) {
    if (this.uploadDocuments) {
      return;
    }
    this.ocultarSpinner();
    if (errorFirma == "" && base64Document != "") {
      this._clientFirmaLog.exito(this.solicitudId, 'tramite-spv');
      this._notificationI18n.success('NOTIFICATION.MESSAGE.SE_HA_FIRMADO_EL_DOCUMENTO');

      formDoc.controls["pdfFirmado"].setValue(
        {
          nameDocument: "comprobante_solicitud_tramite_.pdf",
          typeDocument: "application/pdf",
          b64Document: base64Document,
          csv: this.CSV,
        },
        { emitEvent: false }
      );
      //this.downloadPdf(base64Document, "comprobante_solicitud_tramite");
      this.uploadDocuments = true;
      let sendAutorizaciones = this.autorizacion.controls.some((passengerGroup: any) => {
        return (
          passengerGroup.get("send_request_accept").value === true &&
          passengerGroup.get("documento").value !== this.currentUser.numero_documento
        );
      });
      console.log("sendAutorizaciiones", sendAutorizaciones);

      if (sendAutorizaciones) {
        this.mostrarSpinnerMsg("Enviando autorizaciones...");
      } else {
        this.mostrarSpinnerMsg("Registrando el trámite...");
      }
      this._solicitudEmvsService
        .savePdf(formDoc.controls["pdfFirmado"].value, this.solicitudId)

        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (data) => {
            this._clientFirmaLog.subidaOk(this.solicitudId, 'tramite-spv');
            let tramite: TramiteEmvs = {
              id: +this.solicitudId,
              estadoFirma: EstadoTramite.FIRMADO_CON_REGISTRO,
              estado: true,
              procedimiento_id: { id: this.procedimiento.id },
            };

            this._solicitudEmvsService.updateEstadoTramite(tramite)
              .pipe(takeUntil(this.destroy$))
              .subscribe({
                next: (data) => {
                  if (data.estadoFirma == 'PENDIENTE_DE_FIRMA_AUTORIZADOS') {
                    this._notificationI18n.success('NOTIFICATION.MESSAGE.TRAMITE_FINALIZADO_PENDIENTE_AUTORIZADOS', 5000);
                  }
                  else {
                    this._notificationI18n.success('NOTIFICATION.MESSAGE.TRAMITE_FINALIZADO_CON_EXITO', 5000);
                  }
                  setTimeout(() => {
                    this._router.navigate(["/perfil"], {
                      queryParams: { action: 30 },
                    });
                  }, 2000);
                  releaseFirmaSubmitLock(this);
                  this.listadoTramitesService.tramite = null;
                  this.ocultarSpinner();
                },
                error: (error) => {
                  releaseFirmaSubmitLock(this);
                  this.ocultarSpinner();
                },
              });
          },
          error: (err) => {
            releaseFirmaSubmitLock(this);
            this._clientFirmaLog.subidaError(this.solicitudId, 'tramite-spv', err?.message);
            this._notificationI18n.error('NOTIFICATION.MESSAGE.HUBO_PROBLEMAS_PARA_FINALIZAR_SU_TRAMITE_POR_FAVOR_INTENTELO_DE_NUEVO_MAS_TARDE', 5000);
            this._router.navigate(["/inicio"]).then(() => {
              this.ocultarSpinner();
            });
          },
        });
    } else {
      this._clientFirmaLog.error(this.solicitudId, 'tramite-spv', undefined, errorFirma || 'Firma cancelada o fallida');
      this.mostrarSpinnerMsg("Guardando datos completados...");
      this._notificationI18n.warning('NOTIFICATION.MESSAGE.NO_SE_PUDO_FIRMAR_DOCUMENTO', 5000);
      this._servicioGeneral
        .generatePdf(this.tramite.id)

        .pipe(takeUntil(this.destroy$))
        .subscribe((data: any) => {
          formDoc.addControl("pdfNoFirmado", new FormControl(), {
            emitEvent: false,
          });
          formDoc.controls["pdfNoFirmado"].setValue(
            {
              nameDocument: "comprobante_solicitud_tramite_.pdf",
              typeDocument: "application/pdf",
              b64Document: data.file,
              csv: this.CSV,
            },
            { emitEvent: false }
          );
          this._solicitudEmvsService
            .savePdf(formDoc.controls["pdfNoFirmado"].value, this.solicitudId)

            .pipe(takeUntil(this.destroy$))
            .subscribe({
              next: (data) => {
                let tramite: TramiteEmvs = {
                  id: +this.solicitudId,
                  estadoFirma: EstadoTramite.PENDIENTE_DE_FIRMA,
                  estado: true,
                };
                forkJoin([
                  this._solicitudEmvsService.updateTramite(tramite),
                  this._servicioUsuario.clearCurrentTipoFirma()
                ]).pipe(takeUntil(this.destroy$))
                  .subscribe({
                    next: () => {
                      releaseFirmaSubmitLock(this);
                      this._router
                        .navigate(["/perfil"], { queryParams: { action: 30 } })
                        .then(() => {
                          this.ocultarSpinner();
                        });
                    },
                    error: () => {
                      releaseFirmaSubmitLock(this);
                      this._router
                        .navigate(["/perfil"], { queryParams: { action: 30 } })
                        .then(() => {
                          this.ocultarSpinner();
                        });
                    }
                  });
              },
              error: (err) => {
                releaseFirmaSubmitLock(this);
                this._notificationI18n.error('NOTIFICATION.MESSAGE.HUBO_PROBLEMAS_PARA_FINALIZAR_SU_TRAMITE_POR_FAVOR_INTENTELO_DE_NUEVO_MAS_TARDE', 5000);
                this._router.navigate(["/inicio"]).then(() => {
                  this.ocultarSpinner();
                });
              },
            });
        });
    }
  }

  public downloadPdf(base64Document, fileName) {
    if (base64Document) {
      const source = "data:application/pdf;base64," + base64Document;
      const link = document.createElement("a");
      link.href = source;
      link.download = `${fileName}.pdf`;
      link.click();
    }
  }

  convertFile(file: File): Observable<string> {
    const result = new ReplaySubject<string>(1);
    const reader = new FileReader();
    if (file) {
      reader.readAsBinaryString(file);
      reader.onload = (event) =>
        result.next(btoa(event.target.result.toString()));
    }
    return result;
  }

  handleUpload(event) {
    const file = event.target.files[0];
    if (file.size > 15728640) {
      this._notificationI18n.error('NOTIFICATION.MESSAGE.EL_ARCHIVO_SUPERA_LOS_15MB', 5000);
    }
    else if ((!file.type && !file.name.endsWith('.rar')) || (this.tipoFicherosPermitiros.findIndex(x => x === file.type) < 0 && !file.name.endsWith('.rar'))) {
      this._notificationI18n.error('NOTIFICATION.MESSAGE.EL_ARCHIVO_NO_ES_TIENE_UN_FORMATO_VALIDO_LOS_FORMATOS_VALIDOS_SON_RAR_ZIP_JPG_PD', 5000);
    }
    else {
      this.convertFile(file)
        .pipe(takeUntil(this.destroy$))
        .subscribe((base64) => {
          let document = {
            nameDocument: event.target.files[0].name,
            typeDocument: event.target.files[0].type,
            b64Document: base64,
            tramite: this.solicitudId,
            idNextCloud: null,
          };
          this.mapDocumentos.push(document);
        });
    }
  }

  removeFile(index: number): void {
    this.mapDocumentos.splice(index, 1);
  }

  addPuestoArray(): void {
    this.arrayAuxPuestos = this.denominacionPuesto.filter((denominacion) =>
      this.formPuestos
        .get("puesto")
      ["controls"].find(
        (control) =>
          denominacion.id == control["controls"]["denominacion"].value
      )
    );
  }

  deleteTramite() {
    const nombre = this.procedimiento?.nombre || '';
    const ref = this.deleteDialog.open(ConfirmDeleteDialogComponent, {
      data: {
        title: 'Eliminar trámite',
        message: `¿Seguro que quieres eliminar el trámite «${nombre}»? El trámite quedará dado de baja.`,
        confirmLabel: 'Eliminar'
      },
      panelClass: 'gu-dialog-panel'
    });
    ref.afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe((ok) => {
        if (!ok) return;
        this.confirmDelete();
      });
  }

  confirmDelete() {
    this.lastVisitedTab = "";
    if (this.solicitudId != "") {
      this.listadoTramitesService.deleteTramiteForm(this.tramite)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (value) => {
            this._notificationI18n.success('NOTIFICATION.MESSAGE.EL_TRAMITE_SE_HA_ELIMINADO_CON_EXITO');
            this._router.navigate(["/inicio"]);
            //this._boardAdmin.reloadComponent = !this._boardAdmin.reloadComponent;
          },
          error: (err) => {
            console.error(err);
            this._notificationI18n.error('NOTIFICATION.MESSAGE.EL_TRAMITE_NO_SE_HA_PODIDO_ELIMINAR');
          },
        });
    } else {
      this._notificationI18n.success('NOTIFICATION.MESSAGE.HA_SALIDO_DEL_TRAMITE_CON_EXITO');
      this._router.navigate(["/inicio"]);
    }
  }
  private fechasNacimientoValidas(formArray: FormArray): boolean {
    return formArray.controls.every((grupo) => {
      const fecha = grupo.get("fecha_nacimiento");
      return !fecha?.errors?.["fechaMinima"] && !fecha?.errors?.["fechaMaxima"];
    });
  }

  enableAutoSave() {
    const DEBOUNCE_TIME = 1000;

    this.formPuestos
      .get("puesto")
      .valueChanges.pipe(
        debounceTime(DEBOUNCE_TIME),
        tap((puesto) => {
          for (const item of puesto) {
            let denominacion;
            if (typeof item.denominacion === "object") {
              denominacion = item.denominacion;
            } else {
              denominacion =
                this.denominacionPuesto.find(
                  (value) => value.id == item.denominacion
                ) ?? this.denominacionPuesto[0];
            }
            item.denominacion = {
              id: denominacion.id,
              nombre: denominacion.nombre,
              puesto: denominacion.puesto,
            };
          }
        }),
        concatMap((value) =>
          of(
            this._solicitudEmvsService
              .savePuesto(
                new PuestoEmvs(
                  value,
                  { id: this.solicitudId },
                  this.puestoModel?.id,
                  this.puestoModel?.idDocumento1,
                  this.puestoModel?.idDocumento2
                )
              )

              .pipe(takeUntil(this.destroy$))
              .subscribe((puesto) => {
                this.puestoModel = {
                  id: puesto.id,
                  idDocumento1: puesto.idDocumento1,
                  idDocumento2: puesto.idDocumento2,
                };
                for (let [index, control] of this.formPuestos
                  .get("puesto")
                ["controls"].entries()) {
                  if (!control["controls"]["id"]) {
                    control.addControl("id", new FormControl(""), {
                      emitEvent: false,
                    });
                    control["controls"]["id"].patchValue(
                      puesto.solicitudes[index].id,
                      { emitEvent: false }
                    );
                  }
                }
              })
          )
        )
      )

      .pipe(takeUntil(this.destroy$))
      .subscribe();

    this.formInstancia.valueChanges
      .pipe(
        debounceTime(DEBOUNCE_TIME),
        tap((value) => { }),
        concatMap((value) =>
          of(
            this._solicitudEmvsService
              .saveInstancia({
                ...value,
                id: this.instanciaId,
                tramite: { id: this.solicitudId },
              })

              .pipe(takeUntil(this.destroy$))
              .subscribe((instancia) => {
                this.instanciaId = instancia["id"];
              })
          )
        )
      )

      .pipe(takeUntil(this.destroy$))
      .subscribe();

    this.formCircunstancias.valueChanges
      .pipe(
        debounceTime(DEBOUNCE_TIME),
        concatMap((value) =>
          of(
            this._solicitudEmvsService
              .saveCircunstanciasEmvs({
                ...value,
                id: this.circustanciaId,
                tramite: { id: this.solicitudId },
              })

              .pipe(takeUntil(this.destroy$))
              .subscribe((circustancia) => {
                this.circustanciaId = circustancia["id"];
              })
          )
        )
      )

      .pipe(takeUntil(this.destroy$))
      .subscribe();

    this.formUnidadFamiliar
      .get("familiar")
      .valueChanges.pipe(
        filter(() => !this._isSubmittingFamiliar),
        distinctUntilChanged(),
        throttleTime(1000),
        filter(() => this.formUnidadFamiliar.get("familiar").valid && this.fechasNacimientoValidas(this.formUnidadFamiliar.get("familiar") as FormArray)),
        tap((unidad) => {
          for (const item of unidad) {
            item["tramite"] = { id: this.solicitudId };
            let estadoCivil =
              this.estadosCiviles.find(
                (value) => (value.id == item["estado_civil"] || value.id == item["estado_civil"].id)
              ) ?? this.estadosCiviles[0];
            item["estado_civil"] != undefined
              ? (item["estado_civil"] = {
                id: estadoCivil.id,
                nombre: estadoCivil.nombre,
              })
              : (item["estado_civil"] = null);

            let gradoDiscapacidad =
              this.gradosDiscapacidad.find(
                (value) => (value.id == item["grado_discapacidad"] || value.id == item["grado_discapacidad"].id)
              ) ?? this.gradosDiscapacidad[0];
            item["grado_discapacidad"] != undefined
              ? (item["grado_discapacidad"] = {
                id: gradoDiscapacidad.id,
                nombre: gradoDiscapacidad.nombre,
              })
              : (item["grado_discapacidad"] = null);

            let gradoDependencia =
              this.gradosDependencia.find(
                (value) => (value.id == item["grado_dependencia"] || value.id == item["grado_dependencia"].id)
              ) ?? this.gradosDependencia[0];
            item["grado_dependencia"] != undefined
              ? (item["grado_dependencia"] = {
                id: gradoDependencia.id,
                nombre: gradoDependencia.nombre,
              })
              : (item["grado_dependencia"] = null);
          }
        }),
        //  filter((unidad: any[]) => unidad.every((item: any) => (!item.documento && !esMayorEdad(item.fecha_nacimiento))|| (item.documento && validarLetra(item.documento) ))),    
        concatMap((value) =>
          of(
            value.length > 0
              ? this.saveUnidadFamiliar(value)
              : ""
          )
        )
      )

      .pipe(takeUntil(this.destroy$))
      .subscribe();

    this.formAutorizacion.valueChanges
      .pipe(
        debounceTime(DEBOUNCE_TIME),
        filter(() => this.formAutorizacion.get("autorizacion").valid && this.fechasNacimientoValidas(this.formAutorizacion.get("autorizacion") as FormArray)),
        tap((value) => {
          for (const autorizacion of value["autorizacion"]) {
            autorizacion["tramite"] = { id: this.solicitudId };
            let estadoCivil = this.estadosCiviles.find(
              (value) => value.id == autorizacion["estado_civil"]
            ) ?? { id: 1, nombre: "Soltero/a" };
            autorizacion["estado_civil"] = {
              id: estadoCivil.id,
              nombre: estadoCivil.nombre,
            };
          }
        }),
        concatMap((value) =>
          of(
            this._solicitudEmvsService
              .saveAutorizacion(value["autorizacion"])

              .pipe(takeUntil(this.destroy$))
              .subscribe((autorizacion) => {
                for (let [index, control] of this.formAutorizacion
                  .get("autorizacion")
                ["controls"].entries()) {
                  if (!control["controls"]["id"]) {
                    control.addControl("id", new FormControl(""), {
                      emitEvent: false,
                    });
                    control["controls"]["id"].patchValue(
                      autorizacion[index]["id"],
                      { emitEvent: false }
                    );
                  }
                }
              })
          )
        )
      )

      .pipe(takeUntil(this.destroy$))
      .subscribe();
  }
  private saveUnidadFamiliar(value: any): string | Subscription {

    let dniDuplicado = false;
    let dniValido = true;
    const dnis = new Set<string>();
    for (let [index, control] of this.formUnidadFamiliar.get("familiar")["controls"].entries()) {
      const dni = control["controls"]["documento"]?.value;
      if (dni?.trim()) {
        if (dnis.has(dni)) {
          dniDuplicado = true;
          break;
        }
        dnis.add(dni);
      }
    }
    dniValido = validaNifsArray(value);
    if (!dniDuplicado && dniValido) {
      return this._solicitudEmvsService
        .saveUnidadFamiliar(value)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (tramite) => {
            for (let [index, control] of this.formUnidadFamiliar
              .get("familiar")["controls"].entries()) {
              if (!control["controls"]["id"] && tramite["unidades"][index] && tramite["unidades"][index]["id"]) {
                control.addControl("id", new FormControl(""), {
                  emitEvent: false,
                });
                control["controls"]["id"].patchValue(
                  tramite["unidades"][index]["id"],
                  { emitEvent: false }
                );
              }
            }
          },
          error: (error) => {
            if (error && error.error && (error.error.responseError || error.error.message)) {
              this._notificationI18n.errorDynamic(error.error.responseError ?? error.error.message, 5000);
            }
          }
        });
    }
    else {
      return "";
    }
  }

  restorePersonales() {
    if (this.currentUser.genero) {
      this.formTramite.controls["genero"].patchValue(
        this.currentUser.genero,
        { emitEvent: false }
      );
    }
    this.formTramite.controls["telefono2"].patchValue(
      this.tramite.telefono2,
      { emitEvent: false }
    );
    this.formTramite.controls["telefono3"].patchValue(
      this.tramite.telefono3,
      { emitEvent: false }
    );
    this.formTramite.controls["numeroRegistro"].patchValue(
      this.tramite.numeroRegistroEmvs,
      { emitEvent: false }
    );
  }
  restoreCircustancias() {
    console.log("restoreCircustancias");
    this._solicitudEmvsService
      .getCircustanciasByIdTramite(this.solicitudId)

      .pipe(takeUntil(this.destroy$))
      .subscribe((value) => {
        if (value.body) {
          this.circustanciaId = value.body["id"];
          const cirscustancia = value.body;
          this.formCircunstancias.patchValue(cirscustancia, {
            emitEvent: false,
          });
        }
      });
    this.restorePersonales();
  }

  restoreValuesUnidad() {
    this.getEstadoCivil();
    this.getGradoDiscapacidad();
    this.getGradoDependencia();
    this._solicitudEmvsService
      .getUnidadByIdTramite(this.solicitudId)

      .pipe(takeUntil(this.destroy$))
      .subscribe((value: HttpResponse<any>) => {
        console.log("response restore unidad", value.body);

        if (value.body && value.body.length > 0) {
          this.familiar.clear();
          for (const unidad of value.body) {
            unidad.fecha_nacimiento = unidad?.fecha_nacimiento?.map((item) => {
              if (String(item).length < 2) {
                return "0" + item;
              } else {
                return "" + item;
              }
            });
            /*             if(unidad && unidad.estado_civil){
                          let estado_civil = {
                            id: unidad?.estado_civil?.id,
                            nombre: this.estadosCiviles.find(
                              (value) => value.id == unidad?.estado_civil?.id
                            ).nombre,
                          };
                          console.log(estado_civil);
                        } */
            this.familiar.push(
              new FormGroup({
                id: new FormControl(unidad.id),
                documento: new FormControl(unidad.documento, [
                  Validators.pattern(/^([0-9]{8}[A-Z]|[XYZ][0-9]{7}[A-Z])$/i),
                ]),
                nombre: new FormControl(
                  unidad.nombre,
                  [Validators.required, Validators.maxLength(30)]
                ),
                primerApellido: new FormControl(
                  unidad.primerApellido,
                  [Validators.required, Validators.maxLength(60)]
                ),
                segundoApellido: new FormControl(
                  unidad.segundoApellido,
                  Validators.maxLength(60)
                ),
                fecha_nacimiento: new FormControl(
                  unidad.fecha_nacimiento?.toString().replaceAll(",", "-"),
                  [Validators.required, fechaMinimaValidator(new Date(1920, 0, 1))]
                ),
                parentesco: new FormControl(
                  unidad.parentesco,
                  Validators.required
                ),
                estado_civil: new FormControl(
                  unidad.estado_civil?.id ?? 1,
                  Validators.required
                ),
                grado_discapacidad: new FormControl(
                  unidad.grado_discapacidad?.id ?? 1,
                  Validators.required
                ),
                grado_dependencia: new FormControl(
                  unidad.grado_dependencia?.id ?? 1,
                  Validators.required
                ),
                tramite: new FormControl({ id: this.solicitudId }),
              }, { validators: documentoSegunEdadValidator() }),
              { emitEvent: false }
            );
          }
          console.log("estados", this.estadosCiviles);
        }
      });
  }
  restoreUnidad() {
    this.restoreValuesUnidad();
    console.log("restore de familiar", this.familiar);
    this.restoreCircustancias();
  }


  restoreFicheros() {
    //TODO
    this.uploadDocuments = false;
    this._solicitudEmvsService.getFicheros(this.solicitudId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (value: any) => {
          for (const documento of value.documentos) {
            this._solicitudEmvsService
              .getByIdNexcloud(documento.id_gestor_documental)

              .pipe(takeUntil(this.destroy$))
              .subscribe({
                next: (value: any) => {
                  this.arrayFicheros.push({ nameDocument: value.documento });
                },
                error: (err) => { },
              });
          }
        },
        error: (err) => { },
      });
  }

  restoreAutorizacion() {
    this.getEstadoCivil();
    this._solicitudEmvsService
      .getAutorizacionByIdTramite(this.solicitudId)

      .pipe(takeUntil(this.destroy$))
      .subscribe((value: HttpResponse<any>) => {
        console.log("valor autorizacion recuperado", value);

        if (value.body && value.body.length > 0) {
          this.autorizacionId = value.body["id"];
          const autorizaciones = value.body;
          let form: any = this.formAutorizacion.controls["autorizacion"];
          form.clear({ emitEvent: false });
          for (const autoridad of autorizaciones) {
            autoridad.fecha_nacimiento = autoridad?.fecha_nacimiento?.map(
              (item) => {
                if (String(item).length < 2) {
                  return "0" + item;
                } else {
                  return "" + item;
                }
              }
            );
            form.push(
              new FormGroup({
                id: new FormControl(autoridad.id),
                tramite: new FormControl({ id: this.solicitudId }),
                documento: new FormControl(autoridad?.documento, [
                  Validators.pattern(/^([0-9]{8}[A-Z]|[XYZ][0-9]{7}[A-Z])$/i),
                ]),
                nombre: new FormControl(
                  autoridad?.nombre,
                  [Validators.required, Validators.maxLength(30)]
                ),
                primerApellido: new FormControl(
                  autoridad?.primerApellido,
                  [Validators.required, Validators.maxLength(60)]
                ),
                segundoApellido: new FormControl(
                  autoridad?.segundoApellido,
                  Validators.maxLength(60)
                ),
                fecha_nacimiento: new FormControl(
                  autoridad.fecha_nacimiento?.toString().replaceAll(",", "-"),
                  [Validators.required, fechaMinimaValidator(new Date(1920, 0, 1))]
                ),
                estado_civil: new FormControl(
                  autoridad?.estado_civil?.nombre,
                  Validators.required
                ),
                parentesco: new FormControl(
                  autoridad?.parentesco,
                  Validators.required
                ),
                send_request_accept: new FormControl(
                  autoridad?.send_request_accept
                ),
              }),
              { emitEvent: false }
            );
          }
          console.log("valor autorizacion recuperado", form);
        }
      });
    this.restoreConsulta();
  }

  restoreConsulta() {
    //TODO paso final 2 formulario
    this.restoreUnidad();
  }

  restoreDocumentosPuestos(idDocumento1: string, idDocumento2: string) {
    if (idDocumento1) {
      this._solicitudEmvsService.getByIdNexcloud(idDocumento1)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (value: any) => {
            this.formPuestos.patchValue(
              { documento: value.documento },
              { emitEvent: false }
            );
            this.nombreFilePuesto1 = value.documento;
          },
          error: (err) => { },
        });
    }
    if (idDocumento2) {
      this._solicitudEmvsService.getByIdNexcloud(idDocumento2)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (value: any) => {
            this.formPuestos.patchValue(
              { documento2: value.documento },
              { emitEvent: false }
            );
            this.nombreFilePuesto2 = value.documento;
          },
          error: (err) => { },
        });
    }
  }

  restoreFicherosAdjuntos() {
    this.restoreAutorizacion();

    this._solicitudEmvsService
      .getDocAdjuntosByIdTramite(this.solicitudId)

      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (value: any) => {
          for (const documento of value.documentos) {
            this._solicitudEmvsService
              .getByIdNexcloud(documento.id_gestor_documental)

              .pipe(takeUntil(this.destroy$))
              .subscribe({
                next: (value: any) => {
                  this.mapDocumentos.push({
                    nameDocument: value.documento,
                    idNextCloud: documento.id_gestor_documental,
                  });
                  console.log(this.mapDocumentos);
                },
                error: (err) => { },
              });
          }
        },
        error: (err) => { },
      });
  }
  esNavegable(tabComprobar: string): string {
    if (this.lastVisitedTab != "" && this.lastVisitedTab != undefined) {
      let nombreTabActual: string = "";
      var els = document.getElementsByClassName("nav-link");
      var lastVisist = this.lastVisitedTab;
      Array.prototype.forEach.call(els, function (el) {
        if (document.getElementById(lastVisist) != el)
          el.classList.remove("active");
      });
      if (
        document.getElementById(lastVisist) ===
        document.getElementById(tabComprobar)
      )
        return "nav-link";
      if (document.getElementsByClassName("active nav-link").length > 0) {
        nombreTabActual =
          document.getElementsByClassName("active nav-link")[0].id;
        let indexActual: number = this.tabsComprobar.indexOf(nombreTabActual);
        let indexComprobar: number = this.tabsComprobar.indexOf(tabComprobar);
        return !(
          indexActual > indexComprobar &&
          //!this.submitConsulta &&
          !this.isSigning
        )
          ? "nav-link disabled"
          : "nav-link";
      } else {
        return "nav-link disabled";
      }
    }
    return "nav-link disabled";
  }
  restauraPestaniaSeleccionada(tabRestaurar: string) {
    if (tabRestaurar && this.restauraPestania) {
      if (!this.solicitudId) {
        this.solicitudId = this.tramite.id.toString();
      }
      if (this.tabRestoreBehavior) this.tabRestoreBehavior[tabRestaurar]();
      this.lastVisitedTab = tabRestaurar;
      this.restauraPestania = true;
    } else if (!this.restauraPestania) {
      this.restauraPestania = true;
    }
  }
  public customPatternValid(config: any): ValidatorFn {
    return (control: FormControl) => {
      let urlRegEx: RegExp = config.pattern;
      if (control.value && !control.value.match(urlRegEx)) {
        return {
          invalidMsg: config.msg,
        };
      } else {
        return null;
      }

    };
  }
  volver() {
    if (
      this.lastVisitedTab != "" &&
      this.lastVisitedTab != undefined &&
      this.tabsComprobar.indexOf(this.lastVisitedTab) > 0
    ) {
      var tab =
        this.tabsComprobar[this.tabsComprobar.indexOf(this.lastVisitedTab) - 1];
      document.getElementById(tab).click();
      //if(tab)this.tabRestoreBehavior[tab]();;
    }
  }

  siguiente() {
    if (
      this.lastVisitedTab != "" &&
      this.lastVisitedTab != undefined &&
      this.tabsComprobar.indexOf(this.lastVisitedTab) <
      this.tabsComprobar.length
    ) {
      var tab =
        this.tabsComprobar[this.tabsComprobar.indexOf(this.lastVisitedTab) + 1];
      if (tab == "autorizacion-tab") {
        this.restoreAutorizacion();
      }
      this._solicitudEmvsService
        .updateLastVisitedTab({
          id: +this.solicitudId,
          lastVisitedTab: (this.lastVisitedTab = tab),
        })

        .pipe(takeUntil(this.destroy$))
        .subscribe(() => { });
      document.getElementById(tab).classList.remove("disabled");
      this.restauraPestania = false;
      document.getElementById(tab).click();
      document.getElementById(tab).classList.add("disabled");
    } else {
      var tab = this.tabsComprobar[1];

      this._solicitudEmvsService
        .updateLastVisitedTab({
          id: +this.solicitudId,
          lastVisitedTab: (this.lastVisitedTab = tab),
        })


        .pipe(takeUntil(this.destroy$))
        .subscribe(() => { });
      document.getElementById(tab).classList.remove("disabled");
      this.restauraPestania = false;
      document.getElementById(tab).click();
      document.getElementById(tab).classList.add("disabled");
    }
  }

  mostrarSpinnerMsg(mensaje: string) {
    this.mensajeSpinner = mensaje;
    this.spinner.show('tramite_spv_spinner');
    /*setTimeout(() => {
      this.spinner.hide();
    }, 60000);*/
  }
  ocultarSpinner() {
    this.spinner.hide('tramite_spv_spinner');
  }
  post(path: string, params: any): void {
    let method = "post";
    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);
    for (var key in params) {
      if (params.hasOwnProperty(key)) {
        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
      }
    }
    document.body.appendChild(form);
    form.submit();
  }

  public pdfProcedimientoClave(rId: string, accion: string) {
    //this._notificationI18n.success('NOTIFICATION.MESSAGE.SE_HA_FIRMADO_EL_DOCUMENTO');
    if (accion == "firmar") {
      this.uploadDocuments = true;
      let sendAutorizaciones = this.autorizacion.controls.map(
        (passengerGroup: any, i: number) => {
          console.log(passengerGroup.get("documento").value);
          if (
            passengerGroup.get("send_request_accept").value == true &&
            passengerGroup.get("documento").value !=
            this.currentUser.numero_documento
          ) {
            return true;
          }
          return false;
        }
      );
      console.log("sendAutorizaciiones", sendAutorizaciones);

      if (sendAutorizaciones) {
        this.mostrarSpinnerMsg("Enviando autorizaciones...");
      } else {
        this.mostrarSpinnerMsg("Registrando el trámite...");
      }
      this._claveService.getResultFirma(rId)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (data: any) => {
            if (data.status && data.status == "658") {
              let tramite: TramiteEmvs = {
                id: +this.solicitudId,
                estadoFirma: EstadoTramite.FIRMADO_CON_REGISTRO,
                estado: true,
                procedimiento_id: { id: this.procedimiento.id },
                firmarClave: true,
              };

              this._solicitudEmvsService.updateEstadoTramite(tramite)
                .pipe(takeUntil(this.destroy$))
                .subscribe({
                  next: (data: any) => {


                    if (data.estadoFirma == 'PENDIENTE_DE_FIRMA_AUTORIZADOS') {
                      this._notificationI18n.success('NOTIFICATION.MESSAGE.TRAMITE_FINALIZADO_PENDIENTE_AUTORIZADOS', 5000);
                    }
                    else {
                      this.downloadPdf(
                        data.pdfFirmado,
                        "comprobante_solicitud_tramite"
                      );
                      this._notificationI18n.success('NOTIFICATION.MESSAGE.TRAMITE_FINALIZADO_CON_EXITO', 5000);
                    }
                    setTimeout(() => {
                      this._router.navigate(["/perfil"], {
                        queryParams: { action: 30 },
                      });
                    }, 2000);
                    this.uploadDocuments = false;
                    this.listadoTramitesService.tramite = null;
                    this.ocultarSpinner();
                  },
                  error: (error) => {
                    this.ocultarSpinner();
                  },
                });
            }
          },
          error: (error) => { },
        });
    }
  }

  getUsersOld() {
    if (!this.autorizacion) {
      return [];
    }

    let users = this.autorizacion.controls
      .map((passengerGroup: any, i: number) => {
        if (esMayorEdad(passengerGroup.get("fecha_nacimiento").value)) {
          return passengerGroup;
        }
        return null;
      })
      .filter((passenger) => passenger !== null);

    console.log(users);

    return users;
  }

  /*   public customFechaNacimientoValidator(): ValidatorFn {
      return (control: FormControl) => {
        if(control?.parent?.controls['documento']?.value == this.numerodocumento){
          let anios = esMayorEdad(control?.value);
          return anios < 18 ? { solMenor: true } : null
        }
        return null;
      };
    } */

  checkSolicitantMayorEdad() {
    var control = this.familiar.controls.find(x => x.get('documento')?.value === this.numerodocumento) as FormGroup;
    if (control) {
      return esMayorEdad(control?.controls['fecha_nacimiento']?.value);
    }
    return false;

  }
  checkNoExisteTramite() {
    this.mostrarSpinnerMsg('Revisando su solicitud');
    this.listadoTramitesService.checkDoesntExistSpv(this.idProcedimiento)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (value) => {
          this.ocultarSpinner();
          if (!value || value.codigoSalida == null || value.codigoSalida == 2) {
            this._notificationI18n.warningDynamic(value?.mensajeExito ?? 'Ya figuran sus datos en una solicitud SPV, no es posible dar de alta nuevamente. Diríjase a consultas.sorteo.barajas@emvs.es para cualquier aclaración');
            this._router.navigate(["perfil"], {
              queryParams: { action: 30 },
            });
          }
          else if (value.codigoSalida == 1
            && value.registroExistente
            && this.tramite.sobreescribeTramitePrevio == null
            && this.tramite.numeroRegistroEmvs == null) {
            this.openModalGeneric(value.registroExistente);
          }
        },
        error: (err) => {
          this.ocultarSpinner();
          console.error(err);
          this._notificationI18n.error('NOTIFICATION.MESSAGE.HA_OCURRIDO_UN_ERROR_VALIDANDO_LA_EXISTENCIA_DE_UN_TRAMITE_PREVIO_DE_TIPO_SPV');
        },
      });
  }
  confirmDeleteSvdPrevio() {
    this.lastVisitedTab = "";
    if (this.solicitudId != "") {
      this.listadoTramitesService.deleteTramiteForm(this.tramite)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (value) => {
            this._notificationI18n.success('NOTIFICATION.MESSAGE.EL_TRAMITE_SE_HA_ELIMINADO_CON_EXITO');
            this._router.navigate(["/inicio"]);
            //this._boardAdmin.reloadComponent = !this._boardAdmin.reloadComponent;
          },
          error: (err) => {
            console.error(err);
            this._notificationI18n.error('NOTIFICATION.MESSAGE.EL_TRAMITE_NO_SE_HA_PODIDO_ELIMINAR');
          },
        }); 59
    } else {
      this._notificationI18n.success('NOTIFICATION.MESSAGE.HA_SALIDO_DEL_TRAMITE_CON_EXITO');
      this._router.navigate(["/inicio"]);
    }
  }
  openModalGeneric(numeroRegistro?: string) {
    const dialogRef = this.dialog.open(DialogGenericComponent, {
      width: '600px !important',
      maxWidth: '600px',
      panelClass: 'generic-dialog-container',
      data: { tittle: "Atención", icon: "warning_blue_24dp", question: "Ya existe un trámite SPV previo. ¿Desea actualizarlo o borrarlo?", but1: "Actualizar trámite existente", but2: "Borrar trámite" }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != null) {
        if (result) {
          this.formTramite.controls["numeroRegistro"].patchValue(numeroRegistro, { emitEvent: false });
          this.formTramite.controls["sobreescribeTramitePrevio"].patchValue(true, { emitEvent: false });
        }
        else {
          this.formTramite.controls["numeroRegistro"].patchValue(numeroRegistro, { emitEvent: false });
          this.displayFirma = 'block';
        }
      }
      else {
        this._router.navigate(["perfil"], {
          queryParams: { action: 30 },
        });
      }
    });
  }
  closeModalFirma() {
    this.displayFirma = 'none';
    this._router.navigate(["perfil"], {
      queryParams: { action: 30 },
    });
  }
  mayorDeEdadSinConsentimiento() {
    const autorizaciones = this.formAutorizacion.get("autorizacion") as FormArray;

    if (!autorizaciones || !(autorizaciones instanceof FormArray)) return null;

    const now = new Date();
    for (const grupo of autorizaciones.controls) {
      const fechaNacimiento = grupo.get('fecha_nacimiento')?.value;
      const acepta = grupo.get('send_request_accept')?.value;

      if (fechaNacimiento) {
        const nacimiento = new Date(fechaNacimiento);
        const edad = now.getFullYear() - nacimiento.getFullYear();
        const cumpleMes =
          now.getMonth() > nacimiento.getMonth() ||
          (now.getMonth() === nacimiento.getMonth() && now.getDate() >= nacimiento.getDate());

        const edadFinal = cumpleMes ? edad : edad - 1;

        if (edadFinal >= 18 && !acepta) {
          return true;
        }
      }
    }

    return null; // Todo correcto
  };

  esMayorEdad(fechaNacimiento: string): boolean {
    return esMayorEdad(fechaNacimiento);
  }
  downloadJustificanteFrontP() {
    if (this.procedimiento?.id != -1 && this.displayFirma == 'block') this.downloadJustificanteFront();
  }
  async downloadJustificanteFront() {
    this.isInProgress = true;
    this.actionProgres = true;
    if (this.selectedOpcion == 'Firmar con Autofirma') {
      this.mostrarSpinnerMsg('Solicitando firma baja trámite...')
      this._servicioGeneral.generatePdfDelete(this.procedimiento.id.toString())
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (data: any) => {
            if (isGeneratePdfReady(data)) {
              this.CSV = data.csv
              this.firmaDelete = true;
              this.firmaTramite = false;
              this._clientFirmaLog.iniciada(this.solicitudId, 'tramite-spv');
              this.singFile(data.file);
            }
            else {
              this._notificationI18n.errorPdfGeneration(data, 5000);
              this.isInProgress = false;
              this.actionProgres = false;
              this.ocultarSpinner();
            }
          },
          error: (error) => {
            this.isInProgress = false;
            this.ocultarSpinner()
          }
        });
    }
    else {

      if (this.solicitudId == "" && this.formTramite.controls["numeroRegistro"]?.value != null) {
        try {
          const data = await firstValueFrom(this._servicioGeneral.getTramiteByRegisterId(this.formTramite.controls["numeroRegistro"]?.value).pipe(takeUntil(this.destroy$)));
          if (data && data.id) {
            this.solicitudId = String(data.id);
          }
        } catch (error) {
        }
      }
      this._claveService.iniciaFirma(
        (this.solicitudId == "" ?
          this.procedimiento.id
          : this.solicitudId), (this.solicitudId == "" ? 4 : 5))
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: async (data: SamlRequest) => {
            this.post(data.nodeService, {
              SAMLRequest: data.SamlRequest,
              RelayState: data.RelayState,
            });
          }, error: (error) => {
            this.isInProgress = false;
          }
        });
    }

  }

  public pdfProcedimientoDelete(
    errorFirma: string,
    base64Document: string,
    formDoc: FormGroup
  ) {
    if (this.uploadDocuments) {
      return;
    }
    this.ocultarSpinner();
    if (errorFirma == "" && base64Document != "") {
      this._notificationI18n.success('NOTIFICATION.MESSAGE.SE_HA_FIRMADO_EL_DOCUMENTO');

      formDoc.controls["pdfFirmado"].setValue(
        {
          nameDocument: "comprobante_solicitud_tramite_.pdf",
          typeDocument: "application/pdf",
          b64Document: base64Document,
          csv: this.CSV,
        },
        { emitEvent: false }
      );
      //this.downloadPdf(base64Document, "comprobante_solicitud_tramite");
      this.uploadDocuments = true;
      this.mostrarSpinnerMsg("Eliminando el trámite...");
      this._solicitudEmvsService
        .savePdfClienteFirmadoDelete(formDoc.controls["pdfFirmado"].value, this.solicitudId, this.formTramite.controls["numeroRegistro"].value, this.procedimiento.id)

        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (data) => {
            const pdfJustificante = data?.pdfFirmado ?? base64Document;
            if (pdfJustificante) {
              this.downloadPdf(pdfJustificante, "comprobante_solicitud_tramite");
            }
            this._notificationI18n.info('NOTIFICATION.MESSAGE.SE_HA_ELIMINADO_EL_TRAMITE_CON_EXITO_SE_DESCARGARA_EL_JUSTIFICANTE_DE_ELIMINACIO', 5000);
            this._router
              .navigate(["/perfil"], { queryParams: { action: 30 } })
              .then(() => {
                releaseFirmaSubmitLock(this);
                this.ocultarSpinner();
              });
          },
          error: (err) => {
            releaseFirmaSubmitLock(this);
            this._notificationI18n.error(
              "Error",
              err?.error?.responseError ??
              "Hubo problemas para finalizar su trámite, por favor, inténtelo de nuevo más tarde",
              5000
            );
            this._router.navigate(["/inicio"]).then(() => {
              this.ocultarSpinner();
            });
          },
        });
    } else {
      releaseFirmaSubmitLock(this);
      this.ocultarSpinner();
      this._notificationI18n.warning('NOTIFICATION.MESSAGE.NO_SE_PUDO_FIRMAR_DOCUMENTO', 5000);
      this._router
        .navigate(["/perfil"], { queryParams: { action: 30 } })
        .then(() => {
          this.ocultarSpinner();
        });
    }
  }
}
export function noDuplicateValuesValidator(): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    if (!(group instanceof FormGroup)) {
      return null; // Solo se aplica a FormGroup
    }

    const controls = group.controls;
    const values = Object.values(controls).map(control => control.value);

    // Verificar si hay valores duplicados
    const hasDuplicates = values.some((value, index) => {
      return values.indexOf(value) !== index && value !== null && value !== undefined;
    });

    return hasDuplicates ? { duplicateValues: true } : null;
  };
}
export function documentoSegunEdadValidator(): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const documento = group.get('documento');
    const fechaNacimiento = group.get('fecha_nacimiento');

    if (!documento || !fechaNacimiento) return null;

    const fecha = new Date(fechaNacimiento.value);
    const hoy = new Date();
    const edad = hoy.getFullYear() - fecha.getFullYear();
    const mes = hoy.getMonth() - fecha.getMonth();
    const dia = hoy.getDate() - fecha.getDate();
    const es14OMas = edad > 14 || (edad === 14 && (mes > 0 || (mes === 0 && dia >= 0)));

    if (es14OMas && !documento.value) {
      documento.setErrors({ required: true });
    } else {

      if (documento.getError('pattern')) {
        documento.setErrors(documento.getError('pattern'));
      }
      else {
        if ((!es14OMas && !documento.value) || validarLetra(documento.value)) {
          documento.setErrors(null);
        }
        else {
          documento.setErrors({ pattern: true });
        }
      }
    }

    return null;
  };



}
/**
 * Verifica si un DNI o NIE tiene una letra correcta
 * @param dniNieConLetra DNI o NIE completo, incluyendo la letra al final
 * @returns true si la letra es correcta, false en caso contrario
 */
function validarLetra(dniNieConLetra: string): boolean {
  if (!dniNieConLetra) return false;
  const letras = 'TRWAGMYFPDXBNJZSQVHLCKE';
  dniNieConLetra = dniNieConLetra.toUpperCase().trim();

  const letraRecibida = dniNieConLetra.slice(-1);
  let numero: string;

  // NIE
  if (dniNieConLetra.startsWith('X')) {
    numero = '0' + dniNieConLetra.substring(1, dniNieConLetra.length - 1);
  } else if (dniNieConLetra.startsWith('Y')) {
    numero = '1' + dniNieConLetra.substring(1, dniNieConLetra.length - 1);
  } else if (dniNieConLetra.startsWith('Z')) {
    numero = '2' + dniNieConLetra.substring(1, dniNieConLetra.length - 1);
  } else {
    // DNI
    numero = dniNieConLetra.substring(0, dniNieConLetra.length - 1);
  }

  if (!/^\d+$/.test(numero)) return false;

  const calculada = letras.charAt(parseInt(numero, 10) % 23);
  return calculada === letraRecibida;
}

export function minLengthArray(min: number) {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control instanceof FormArray) {
      return control.length >= min ? null : { minLengthArray: { requiredLength: min } };
    }
    return null;
  };
}
export function fechaMinimaValidator(minDate: Date) {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }
    const fechaIngresada = new Date(control.value);
    if (fechaIngresada < minDate) {
      return { fechaMinima: { value: control.value } };
    }
    if (fechaIngresada > new Date()) {
      return { fechaMaxima: { value: control.value } };
    }
    return null;
  };
}

export function validaNifsForm(entries: any): boolean {

  for (let [index, control] of entries) {
    const dni = control["controls"]["documento"]?.value;
    const fechaNacimiento = control["controls"]["fecha_nacimiento"]?.value;
    const nombre = control["controls"]["nombre"]?.value;
    const apellido1 = control["controls"]["primerApellido"]?.value;
    const parentesco = control["controls"]["parentesco"]?.value;
    if ((!nombre || nombre == '') || (!apellido1 || apellido1 == '') || (!parentesco || parentesco == '') || (!fechaNacimiento || fechaNacimiento == ''))
      return false;
    if (((!dni || dni == '') && esMayorEdad(fechaNacimiento)) || (dni && dni != '' && !validarLetra(dni)))
      return false;
  }
  return true;
}
export function validaNifsArray(entries: any): boolean {

  for (let entry of entries) {
    const dni = entry.documento;
    const fechaNacimiento = entry.fecha_nacimiento;
    if (((!dni || dni == '') && esMayorEdad(fechaNacimiento)) || (dni && dni != '' && !validarLetra(dni)))
      return false;
  }
  return true;
}
export function esMayorEdad(fechaNacimiento: string): boolean {
  if (fechaNacimiento) {
    const hoy = new Date();
    const nacimiento = new Date(fechaNacimiento);
    let edad = hoy.getFullYear() - nacimiento.getFullYear();
    if (edad > 18) return true;
    if (edad < 18) return false;
    if (hoy.getMonth() < nacimiento.getMonth()) return false;
    if (hoy.getMonth() == nacimiento.getMonth() && hoy.getDate() < nacimiento.getDate()) return false

    return true;
  }
  return false;
}
